import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import ScreenHeading from "../../Utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../Utilities/ScrollService";
import Animations from "../../Utilities/Animations";
import "./Testimonials.css";

import Testifier from "../../../src/img/Testimonial/testifier.jpg";
// import Testifier2 from "../../../src/img/Testimonial/twins-pharmacy.jpg";
// import Testifier3 from "../../../src/img/Testimonial/united-states-patent.jpg";
// import Testifier4 from "../../../src/img/Testimonial/landmark-technologies.jpg";
import shape from "../../../src/img/Testimonial/shape-bg.png";
//Import other images similarly

export default function Testimonial(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };

  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const options = {
    loop: true,
    margin: 0,
    nav: true,
    animateIn: "bounceInRight",
    animateOut: "bounceOutRight",
    dots: true,
    autoplay: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1000: {
        items: 3,
      },
    },
  };

  return (
    <div>
      <ScreenHeading
        title={"Testimonials"}
        subHeading={"What Some Associates Have Said About Me."}
      />
      <section className="testimonial-section fade-in" id={props.id || ""}>
        <div className="container">
          <div className="row">
            <OwlCarousel
              className="owl-carousel"
              id="testimonial-carousel"
              {...options}
            >
              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testimony">
                    <p>
                      <i className="fa fa-quote-left" />
                      Florence is an exceptional problem solver. She has a knack for identifying 
                      bottlenecks and implementing innovative solutions to streamline our processes. 
                      Her expertise in automation and continuous integration/continuous deployment 
                      (CI/CD) pipelines significantly improved our team's productivity and time-to-market.
                      <i className="fa fa-quote-right" />
                    </p>
                  </div>
                  <div className="rating">
                    <ul className="stars list-unstyled">
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                    </ul>
                  </div>
                  <div className="client-info">
                    <div>
                      <img src={Testifier} alt="no internet connection"></img>
                    </div>
                    <div className="client-name">
                      <h5>John Omar</h5>
                      <p>Dominion Systems</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testimony">  
                    <p>
                      <i className="fa fa-quote-left" />
                      Working with Florence made a significant impact on our pharmacy's efficiency and 
                      productivity. She is highly organized and detail-oriented, ensuring accurate and 
                      timely dispensing of medications. Her strong problem-solving skills and ability to 
                      handle high-pressure situations were invaluable during busy periods. 
                      Florence consistently demonstrated professionalism and maintained a calm demeanor, 
                      inspiring confidence in the team.
                      <i className="fa fa-quote-right" />
                    </p>
                  </div>
                  <div className="rating">
                    <ul className="stars list-unstyled">
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                    </ul>
                  </div>
                  <div className="client-info">
                    <div>
                      <img src={Testifier} alt="no internet connection"></img>
                    </div>
                    <div className="client-name">
                      <h5>Chris Olivo</h5>
                      <p>Twins Pharmacy</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="testi-item">
                  <div className="testimony">
                    <p>
                      <i className="fa fa-quote-left" />
                      I had the pleasure of working alongside Florence in the pharmacy, and I must say she 
                      is an incredibly knowledgeable and skilled pharmacist. Her attention to detail and 
                      commitment to patient care were truly remarkable. Florence consistently demonstrated 
                      expertise in medication management and was always willing to go the extra mile to 
                      ensure the best outcomes for our patients.
                      <i className="fa fa-quote-right" />
                    </p>
                  </div>
                  <div className="rating">
                    <ul className="stars list-unstyled">
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                      <li>
                        <i className="fa fa-star" />
                      </li>
                    </ul>
                  </div>
                  <div className="client-info">
                    <div>
                      <img src={Testifier} alt="no internet connection"></img>
                    </div>
                    <div className="client-name">
                      <h5>Julia Gordon</h5>
                      <p>Rite Aid Pharmacy</p>
                    </div>
                  </div>
                </div>
              </div>
            </OwlCarousel>
          </div>
        </div>
      </section>
      <div className="footer-image">
        <img src={shape} alt="Unable to load" />
      </div>
    </div>
  );

}